import {
  call,
  delay,
  put,
  takeLatest,
  take,
  cancelled,
  fork,
  select,
  throttle,
  takeEvery,
} from "redux-saga/effects";
import {
  fetchData,
  setData,
  setError,
  changeThemeAfterDelay,
  selectIsLightMode,
  setTimeOfDay,
  fetchSuggestionDetails,
  setSuggestionDetails,
  setDocumentError,
  selectData,
  setSuggestions,
  selectContentSuggestions,
  selectCommentSuggestions,
  selectThemedSuggestions,
  setContentSuggestions,
  setCommentSuggestions,
  setThemedSuggestions,
  setLegalAdvice,
  setGeneratedDocument,
  startDocumentGeneration,
  saveChatHistory,
  selectChatbotId,
  setChatHistory,
  setUser,
  fetchRestrictedData,
  setTilesDetails,
  selectUser,
  setImageUrl,
   setVideoTaskId,
  setVideoUrl,
  selectVideoTaskId,
  setMusicTaskId,
  setMusicUrl,
  setMusicError,
  setMusicProgress,
  selectMusicTaskId,
  setMusicResult,
   startMusicProgressTimer,
  updateMusicTimerProgress,
  completeMusicTimer,
  resetMusicTimer,
  selectMusicResult,
  selectMusicTimerActive,
  selectMusicChatbotId, // DODANE: nowy action
  // Video timer
  startVideoProgressTimer,
  updateVideoTimerProgress,
  completeVideoTimer,
  resetVideoTimer,
  selectVideoTimerActive,
  setLastDietPlan,
  setLoadingSuccess,
  setOpenAiTokens,
  fetchActiveSubscription,
  setActiveSubscription,
  setUserData,
  fetchUserData,
} from "../DataSlice/dataSlice";
// Music generation is now handled by Firestore listener in component (like VideoCreator)
// import { generateMusic, checkMusicStatus } from "../../../aiApp/components/Bots/MusicCreator/apiService";
import { saveThemeInLocalStorage } from "./localStorage";
import {
  fetchArticleTitles,
  fetchArticleContent,
} from "../../../aiApp/components/Bots/Articles/apiService";
import {
  fetchSuggestions as fetchVideoIdeas,
  fetchSuggestionDetails as fetchVideoIdeasDetails,
} from "../../../aiApp/components/Bots/Reels/apiService";

import {
  fetchSearchSuggestions,
  fetchSearchDetails,
} from "../../../aiApp/components/Bots/SearchEngine/apiService";

import {
  fetchSuggestions as fetchFacebookSuggestions,
  fetchSuggestionDetails as fetchFacebookPost,
} from "../../../aiApp/components/Bots/FacebookPost/apiService";

import {
  fetchSuggestions as fetchAdvancedSuggestions,
  fetchSuggestionDetails as fetchAdvancedDetails,
} from "../../../aiApp/components/Bots/SocialMedia/apiService";
import {
  fetchAdvertisementSuggestions as fetchAdvertisementSuggestionsAPI,
  fetchAdvertisementDetails as fetchAdvertisementDetailsAPI,
} from "../../../aiApp/components/Bots/Advertisement/apiService";
import {
  fetchDietSuggestions as fetchDietSuggestionsAPI,
  fetchDietDetails as fetchDietDetailsAPI,
} from "../../../aiApp/components/Bots/DietAdvisor/apiService";
import { fetchImage } from "../../../aiApp/components/Bots/ImageCreator/apiService";
import { fetchLegalAdvice, generateLegalDocument } from "../../../aiApp/components/Bots/Lawyer/apiService";
import { auth, db } from "../../../aiApp/components/firebase";
import { collection, addDoc, query, where, getDocs, orderBy, limit, doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { eventChannel } from "redux-saga";

const getCurrentHour = () => new Date().getHours();

function* handleError(context, message) {
  yield put(setError({ context, message }));
}

function* fetchDataWorker() {
  yield delay(600);
  const chatbotId = yield select(selectChatbotId);
  if (chatbotId === "diet") {
    yield put(setLoadingSuccess());
  } else {
    yield put(setData([]));
  }
}

function* fetchLegalAdviceWorker({ payload: { query, chatHistory } }) {
  try {
    const response = yield call(fetchLegalAdvice, query, chatHistory || []);
    yield put(setLegalAdvice(response));
    // Historia jest teraz zapisywana bezpośrednio w komponencie jako cała rozmowa
    // Nie zapisujemy tutaj pojedynczych odpowiedzi
  } catch (error) {
    yield handleError("suggestions", "Wystąpił błąd podczas ładowania analiz prawnych.");
  }
}

function* generateLegalDocumentWorker({ payload }) {
  try {
    // Usunięto put(startDocumentGeneration()), ponieważ jest już w komponencie
    const { documentType, details } = payload;
    // ZMIANA 1: Zmiana nazwy zmiennej i wywołanie nowej akcji
    const response = yield call(generateLegalDocument, documentType, details);
    yield put(setGeneratedDocument(response)); // Używamy nowej akcji

    const chatbotId = yield select(selectChatbotId);
    if (chatbotId === "lawyer") {
      yield put(
        saveChatHistory({
          title: `Dokument: ${documentType}`,
          // ZMIANA 2: Przekazujemy tylko treść do historii
          content: response.content,
        })
      );
    }
  } catch (error) {
    // ZMIANA 3: Przekazujemy komunikat błędu do reducera
    yield put(setDocumentError(error.message));
  }
}

function* fetchSuggestionsWorker({ payload: category }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    let response;

    if (chatbotId === "reels") {
      response = yield call(fetchVideoIdeas, category);
    } else if (chatbotId === "facebook") {
      response = yield call(fetchFacebookSuggestions, category);
    } else if (chatbotId === "searchengine") {
      response = yield call(fetchSearchSuggestions, category);
      yield put(fetchUserData());
    }

    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }

    const content = response.content || response;
    let dataForUi;

    if (chatbotId === "searchengine") {
      const parsed = parseSearchSuggestions(content);
      dataForUi = parsed.length > 0 ? parsed : content;
    } else {
      dataForUi =
        typeof content === "string" && content.includes("1.")
          ? parseSuggestions(content)
          : content;
    }

    yield put(setSuggestions(dataForUi));

    // Ustawienie contentSuggestions dla wszystkich botów oprócz wyszukiwarki
    if (chatbotId !== "searchengine") {
      yield put(setContentSuggestions(dataForUi));
    }

    if (chatbotId === "reels") {
      yield put(
        saveChatHistory({
          title: `Sugestie dla kategorii: ${category}`,
          content: JSON.stringify(dataForUi),
        })
      );
    } else if (chatbotId === "facebook") {
      yield put(
        saveChatHistory({
          title: `Pomysły na posty dla kategorii: ${category}`,
          content: JSON.stringify(dataForUi),
        })
      );
    } else if (chatbotId === "searchengine") {
      yield put(
        saveChatHistory({
          title: `Wyniki wyszukiwania dla: ${category}`,
          content: JSON.stringify(dataForUi),
        })
      );
    }
  } catch (error) {
    yield handleError("suggestions", error.message);
  }
}

function* fetchAdvertisementSuggestionsWorker({ payload: { platform, description } }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    if (chatbotId !== "advertisement") return;
    const response = yield call(fetchAdvertisementSuggestionsAPI, platform, description);
    
    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }

    const content = response.content || response;
    const parsedData = typeof content === "string" && content.includes("1.")
      ? parseAdvertisementSuggestions(content)
      : content;
    yield put(setSuggestions(parsedData));
    yield put(
      saveChatHistory({
        title: `Ogłoszenia ${platform}: ${description.substring(0, 50)}...`,
        content: JSON.stringify(parsedData),
      })
    );
  } catch (error) {
    yield handleError("suggestions", error.message);
  }
}

function* fetchDietSuggestionsWorker({ payload }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    if (chatbotId !== "diet") return;
    const response = yield call(fetchDietSuggestionsAPI, payload);

    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }

    const content = response.content || response;
    const parsedData = parseDietSuggestions(content);
    yield put(setSuggestions(parsedData));
    yield put(
      saveChatHistory({
        title: `Plan diety: ${payload.goal}`,
        content: JSON.stringify(parsedData),
        userInput: payload,
        type: 'suggestions',
      })
    );
  } catch (error) {
    yield handleError("suggestions", error.message);
  }
}

function* fetchAdvancedSuggestionsWorker({ payload: { category, platform, contentType, comment, commentType, themeType } }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    if (chatbotId !== "advanced") return;
    const response = yield call(
      fetchAdvancedSuggestions,
      category,
      platform,
      contentType,
      comment,
      commentType,
      themeType
    );

    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }
    
    const content = response.content || response;
    const parsedData = typeof content === "string" && content.includes("1.")
      ? parseAdvancedSuggestions(content, contentType)
      : content;
    yield put(setSuggestions(parsedData));
    if (contentType === "themed") {
      yield put(setThemedSuggestions(parsedData));
    } else if (contentType === "comment") {
      yield put(setCommentSuggestions(parsedData));
    } else {
      yield put(setContentSuggestions(parsedData));
    }
    yield put(
      saveChatHistory({
        title: `Sugestie ${contentType} dla ${platform}: ${category || comment?.substring(0, 50)}`,
        content: JSON.stringify(parsedData),
      })
    );
  } catch (error) {
    yield handleError("suggestions", error.message);
  }
}

function* fetchCommentResponseWorker({ payload: { comment, commentType, platform } }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    if (chatbotId !== "advanced") return;
    const response = yield call(fetchAdvancedSuggestions, null, platform, null, comment, commentType);

    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }

    const content = response.content || response;
    const parsedData = typeof content === "string" && content.includes("1.")
      ? parseAdvancedSuggestions(content, 'comment')
      : content;
    yield put(setSuggestions(parsedData));
    yield put(setCommentSuggestions(parsedData));
    yield put(
      saveChatHistory({
        title: `Odpowiedzi na komentarz (${commentType}): ${comment.substring(0, 50)}...`,
        content: JSON.stringify(parsedData),
      })
    );
  } catch (error) {
    yield handleError("suggestions", error.message);
  }
}

function* fetchImageWorker({ payload }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    if (chatbotId !== "image") return;
    const response = yield call(fetchImage, payload);

    if (response && response.content) {
      yield put(setImageUrl(response.content));
      yield put(fetchUserData()); // Odśwież dane użytkownika
    }

    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }

    yield put(
      saveChatHistory({
        title: `Obraz: ${payload.category} (${
         payload.model === "flux-schnell" ? "standard" : "premium"
        }${payload.style ? `, ${payload.style}` : ""}, ${payload.language})`,
        content: `<img src="${response.content}" alt="" />`,
      })
    );
  } catch (error) {
    yield handleError("suggestions", error.message);
  }
}

function* fetchSuggestionDetailsWorker({ payload }) {
  try {
    const contentSuggestions = yield select(selectContentSuggestions);
    const commentSuggestions = yield select(selectCommentSuggestions);
    const themedSuggestions = yield select(selectThemedSuggestions);
    const chatbotId = yield select(selectChatbotId);
    let details;
    if (chatbotId === "advertisement") {
      const { index, platform, description } = payload;
      const suggestions = yield select(selectData);
      if (!suggestions[index]) {
        yield put(setDocumentError());
        return;
      }
      const suggestion = suggestions[index];
      details = yield call(
        fetchAdvertisementDetailsAPI,
        suggestion.title,
        suggestion.description,
        platform,
        description
      );

      if (details && details.remainingTokens !== undefined) {
        yield put(setOpenAiTokens(details.remainingTokens));
      }

      const content = details.content || details;
      yield put(setSuggestionDetails(content));
      yield put(
        saveChatHistory({
          title: `Szczegóły ogłoszenia: ${suggestion.title}`,
          content: content,
        })
      );
    } else if (chatbotId === "diet") {
      const { index, dayTitle, dayDescription, weight, height, goal, likedProducts, dietType, gender } = payload;
      const suggestions = yield select(selectData);
      if (!suggestions[index]) {
        yield put(setDocumentError());
        return;
      }
      details = yield call(
        fetchDietDetailsAPI,
        { dayTitle, dayDescription, weight, height, goal, likedProducts, dietType, gender }
      );

      if (details && details.remainingTokens !== undefined) {
        yield put(setOpenAiTokens(details.remainingTokens));
      }
      
      const content = details.content || details;
      yield put(setSuggestionDetails(content));
      yield put(
        saveChatHistory({
          title: `Szczegóły diety: ${dayTitle}`,
          content: content,
          type: 'details',
        })
      );
    } else if (chatbotId === "advanced") {
      const { index, platform, contentType, commentType, themeType, category } = payload;
      let suggestions;
      if (contentType === "comment") {
        suggestions = commentSuggestions;
      } else if (contentType === "themed") {
        suggestions = themedSuggestions;
      } else {
        suggestions = contentSuggestions;
      }
      if (!suggestions[index]) {
        yield put(setDocumentError());
        return;
      }
      const suggestion = suggestions[index];
      const description = suggestion.description || "Brak opisu – generuj treść na podstawie tytułu.";
      const title = suggestion.title || "";
      details = yield call(
        fetchAdvancedDetails,
        title,
        description,
        platform,
        contentType,
        commentType,
        themeType,
         category 
      );

      if (details && details.remainingTokens !== undefined) {
        yield put(setOpenAiTokens(details.remainingTokens));
      }
      
      const content = details.content || details;
     
      yield put(setSuggestionDetails(content));

      const historyTitle = suggestion.title 
        ? `Szczegóły ${contentType}: ${suggestion.title}`
        : `Szczegóły ${contentType}: ${suggestion.description.substring(0, 50)}...`;
      yield put(
        saveChatHistory({
          title: historyTitle,
          content: content,
        })
      );
    }  else if (chatbotId === "articles") {
      yield call(fetchArticleContentWorker, { payload });
    } else if (chatbotId === "searchengine") {
      const index = payload;
      const suggestions = yield select(selectData);
      if (!suggestions[index]) {
        yield put(setDocumentError());
        return;
      }
      const suggestion = suggestions[index];
      details = yield call(fetchSearchDetails, {
        url: suggestion.link,
      });
      yield put(fetchUserData());

      if (details && details.remainingTokens !== undefined) {
        yield put(setOpenAiTokens(details.remainingTokens));
      }

      const content = details.content || details;
      yield put(setSuggestionDetails(content));
      yield put(
        saveChatHistory({
          title: `Streszczenie dla: ${suggestion.title}`,
          content: content,
        })
      );
    } else {
      const index = payload;
      const suggestions = contentSuggestions;
      if (!suggestions[index]) {
        yield put(setDocumentError());
        return;
      }
      const suggestion = suggestions[index];
      const description = suggestion.description || "Brak opisu – generuj post na podstawie tytułu.";
      if (chatbotId === "reels") {
        details = yield call(fetchVideoIdeasDetails, suggestion.title, description);
      } else if (chatbotId === "facebook") {
        details = yield call(fetchFacebookPost, suggestion.title, description);
      }
      
      if (details && details.remainingTokens !== undefined) {
        yield put(setOpenAiTokens(details.remainingTokens));
      }
      
      const content = details.content || details;
      yield put(setSuggestionDetails(content));
      if (chatbotId === "reels") {
        yield put(
          saveChatHistory({
            title: `Szczegóły: ${suggestion.title}`,
            content: content,
          })
        );
      } else if (chatbotId === "facebook") {
        yield put(
          saveChatHistory({
            title: `Gotowy post: ${suggestion.title}`,
            content: content,
          })
        );
      }
    }
  } catch (error) {
    console.error('fetchSuggestionDetailsWorker error:', error);
    yield put(setDocumentError(error.message));
  }
}

function* saveChatHistoryWorker({ payload }) {
  try {
    const { title, content, forceChatbotId, ...rest } = payload;
    const chatbotId = forceChatbotId || (yield select(selectChatbotId));
    const user = auth.currentUser;
    if (user) {
      const docRef = yield call(addDoc, collection(db, `Users/${user.uid}/chatHistory`), {
        chatbotId,
        title,
        content,
        ...rest,
        timestamp: new Date().toISOString(),
      });
    } else {
      yield put(setError({ context: "history", message: "Użytkownik nie jest zalogowany." }));
    }
  } catch (error) {
    yield put(setError({ context: "history", message: error.message }));
  }
}






function* fetchChatHistoryWorker() {
  try {
    const user = auth.currentUser;
    if (!user) {
      console.log("No user logged in");
      yield put(setError({ context: "history", message: "Użytkownik nie jest zalogowany." }));
      return;
    }
   
    const q = query(
      collection(db, `Users/${user.uid}/chatHistory`),
      orderBy("timestamp", "desc")
    );
    const querySnapshot = yield call(getDocs, q);
   
    const history = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Processed history:", history);
    yield put(setChatHistory(history));
    console.log("Dispatched setChatHistory with:", history);
  } catch (error) {
    console.error("Fetch history error:", error);
    yield put(setError({ context: "history", message: "Błąd podczas pobierania historii." }));
  }
}

function* videoGenerationCompletedWorker({ payload }) {
  try {
    yield put({ type: "FETCH_CHAT_HISTORY" });
  } catch (error) {
    console.error("Błąd w videoGenerationCompletedWorker:", error);
  }
}

function* fetchLastDietPlanWorker() {
  try {
    let user = yield select(selectUser);
    if (!user) {
      const action = yield take(setUser.type);
      user = action.payload;
    }

    if (!user) {
      yield put(setLastDietPlan(null));
      return;
    }

    const q = query(
      collection(db, `Users/${user.uid}/chatHistory`),
      where("chatbotId", "==", "diet"),
      where("type", "==", "suggestions"),
      orderBy("timestamp", "desc"),
      limit(1)
    );
    const querySnapshot = yield call(getDocs, q);
    if (!querySnapshot.empty) {
      const lastPlanDoc = querySnapshot.docs[0].data();
      const suggestions = JSON.parse(lastPlanDoc.content);
      const userInput = lastPlanDoc.userInput;
      yield put(setLastDietPlan({ suggestions, userInput }));
    } else {
      yield put(setLastDietPlan(null));
    }
  } catch (error) {
    console.error("Błąd podczas pobierania ostatniego planu diety:", error);
    yield put(setError({ context: "suggestions", message: "Błąd podczas wczytywania ostatniego planu." }));
  }
}

function* fetchActiveSubscriptionWorker() {
  try {
    const user = yield select(selectUser);
    if (!user) {
      yield put(setActiveSubscription(null));
      return;
    }

    const subscriptionsRef = collection(db, `Users/${user.uid}/subscriptions`);
    const q = query(
      subscriptionsRef,
      where("status", "in", ["trialing", "active"])
    );
    const querySnapshot = yield call(getDocs, q);

    if (querySnapshot.empty) {
      yield put(setActiveSubscription(null));
      return;
    }

    const activeSub = querySnapshot.docs[0].data();

    // Wyciągnij priceId. Ze zrzutu ekranu wynika, że jest w `price.id`
    // ale Stripe może go też umieścić w `items[0].price.id`.
    // Zapewniamy obie możliwości.
    const priceId = activeSub.price?.id || activeSub.items?.[0]?.price?.id;

    if (priceId) {
      yield put(setActiveSubscription({ ...activeSub, priceId }));
    } else {
      console.warn("Nie znaleziono priceId w aktywnej subskrypcji:", activeSub);
      yield put(setActiveSubscription(null));
    }
  } catch (error) {
    console.error("Błąd podczas pobierania aktywnej subskrypcji:", error);
    yield put(setError({ context: "subscription", message: error.message }));
    yield put(setActiveSubscription(null));
  }
}

function* changeThemeAfterDelayWorker() {
  yield put(changeThemeAfterDelay());
  const lightMode = yield select(selectIsLightMode);
  yield call(saveThemeInLocalStorage, lightMode);
}

function* setTimeOfDayWorker() {
  const currentHour = yield call(getCurrentHour);
  const isDayTime = currentHour >= 10 && currentHour < 19;
  yield put(setTimeOfDay(isDayTime));
}

function createAuthChannel() {
  return eventChannel((emit) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      emit({ user });
    });
    return unsubscribe;
  });
}

function* watchAuthStateChanges() {
  const authChannel = yield call(createAuthChannel);
  try {
    while (true) {
      const { user } = yield take(authChannel);
      yield put(setUser(user));
      if (user && user.emailVerified) {
        yield put(fetchUserData());
        yield put(fetchRestrictedData());
        yield put({ type: "FETCH_CHAT_HISTORY" });
        yield put(fetchActiveSubscription()); // <-- DODANA LINIA
      }
    }
  } finally {
    if (yield cancelled()) {
      authChannel.close();
    }
  }
}

function* fetchUserDataWorker() {
  try {
    const user = yield select(selectUser);
    if (user) {
      const userDocRef = doc(db, 'Users', user.uid);
      const userDoc = yield call(getDoc, userDocRef);
      if (userDoc.exists()) {
        yield put(setUserData(userDoc.data()));
      }
    }
  } catch (error) {
    console.error("Błąd podczas pobierania danych użytkownika:", error);
  }
}

function* fetchRestrictedDataWorker() {
  try {
    const user = yield select(selectUser);
    if (!user) {
      yield put(setError({ context: "restrictedData", message: "Użytkownik nie jest zalogowany." }));
      return;
    }
    const querySnapshot = yield call(getDocs, collection(db, "RestrictedData"));
    const data = querySnapshot.docs.map((doc) => doc.data());
    yield put(setTilesDetails(data));
  } catch (error) {
    console.error("Błąd podczas pobierania danych z RestrictedData:", error);
    yield put(setError({ context: "restrictedData", message: "Wystąpił błąd podczas ładowania danych." }));
  }
}

function* fetchArticleTitlesWorker({ payload: { topic, writerStyle, articleType, articleGenre } }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    if (chatbotId !== "articles") return;
    const response = yield call(fetchArticleTitles, topic, writerStyle, articleType, articleGenre);

    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }

    const content = response.content || response;
    const parsedData = typeof content === "string" && content.includes("1.")
      ? parseArticleTitles(content)
      : content;
    yield put(setSuggestions(parsedData));
    yield put(
      saveChatHistory({
        title: `Tytuły artykułów: ${topic} (${writerStyle}, ${articleType}, ${articleGenre})`,
        content: JSON.stringify(parsedData),
      })
    );
  } catch (error) {
    yield handleError("suggestions", error.message);
  }
}

function* fetchArticleContentWorker({ payload }) {
  try {
    const chatbotId = yield select(selectChatbotId);
    if (chatbotId !== "articles") return;
    const { index, topic, writerStyle, articleType, articleGenre } = payload;
    const suggestions = yield select(selectData);
    if (!suggestions[index]) {
      yield put(setDocumentError());
      return;
    }
    const title = suggestions[index].title;
    const response = yield call(fetchArticleContent, title, topic, writerStyle, articleType, articleGenre);

    if (response && response.remainingTokens !== undefined) {
      yield put(setOpenAiTokens(response.remainingTokens));
    }
    
    const content = response.content || response;
    yield put(setSuggestionDetails(content));
    yield put(
      saveChatHistory({
        title: `Artykuł: ${title}`,
        content: content,
      })
    );
  } catch (error) {
    console.error('fetchArticleContentWorker error:', error);
    yield put(setDocumentError(error.message));
  }
}

// Music generation is now handled directly in component via Firestore listener (like VideoCreator)
// fetchMusicWorker is no longer needed - component calls start-music-generation directly

function* musicProgressTimerWorker() {
  const totalDuration = 5 * 60 * 1000; // 5 minut
  const updateInterval = 1000;
  
  // POPRAWIONE OBLICZENIA na podstawie matematyki:
  // V = 0.708% na sekundę (pełna prędkość)
  const segment1Time = 35294; // ~35.3s dla 0-25%
  const segment2Time = 52941; // ~52.9s dla 25-50%  
  const segment3Time = 211765; // ~211.8s dla 50-100%
  
  let currentProgress = 0;
  let elapsedTime = 0;
  
  while (currentProgress < 100) {
    yield delay(updateInterval);
    elapsedTime += updateInterval;
    
    // Jeśli timer został zresetowany z UI (np. status completed/error) – wyjdź
    const timerActive = yield select(selectMusicTimerActive);
    if (!timerActive) {
      return;
    }
    
    const musicResult = yield select(selectMusicResult);
    if (musicResult && musicResult.status === 'completed') {
      yield put(resetMusicTimer());
      return;
    }
    
    if (elapsedTime <= segment1Time) {
      // SEGMENT 1: 0-25% z prędkością 0.708% na sekundę
      currentProgress = (elapsedTime / segment1Time) * 25;
    } else if (elapsedTime <= segment1Time + segment2Time) {
      // SEGMENT 2: 25-50% z prędkością 0.472% na sekundę
      const segmentElapsed = elapsedTime - segment1Time;
      const segmentProgress = (segmentElapsed / segment2Time) * 25;
      currentProgress = 25 + segmentProgress;
    } else if (elapsedTime <= totalDuration) {
      // SEGMENT 3: 50-100% z prędkością 0.236% na sekundę
      const segmentElapsed = elapsedTime - segment1Time - segment2Time;
      const segmentProgress = (segmentElapsed / segment3Time) * 50;
      currentProgress = 50 + segmentProgress;
    }
    
    currentProgress = Math.min(currentProgress, 100);
    yield put(updateMusicTimerProgress(Math.round(currentProgress)));
    
    if (currentProgress >= 100) {
      yield put(completeMusicTimer());
      break;
    }
  }
}

// Identyczny timer dla wideo – symulowany progres aż do zakończenia
function* videoProgressTimerWorker() {
  const totalDuration = 5 * 60 * 1000; // 5 minut
  const updateInterval = 1000;

  // Segmenty identyczne jak w muzycznym timerze
  const segment1Time = 35294; // ~35.3s dla 0-25%
  const segment2Time = 52941; // ~52.9s dla 25-50%
  const segment3Time = 211765; // ~211.8s dla 50-100%

  let currentProgress = 0;
  let elapsedTime = 0;

  while (currentProgress < 100) {
    yield delay(updateInterval);
    elapsedTime += updateInterval;

    // Jeśli timer został zresetowany z UI (np. status completed/error) – wyjdź
    const timerActive = yield select(selectVideoTimerActive);
    if (!timerActive) {
      return;
    }

    if (elapsedTime <= segment1Time) {
      currentProgress = (elapsedTime / segment1Time) * 25;
    } else if (elapsedTime <= segment1Time + segment2Time) {
      const segmentElapsed = elapsedTime - segment1Time;
      const segmentProgress = (segmentElapsed / segment2Time) * 25;
      currentProgress = 25 + segmentProgress;
    } else if (elapsedTime <= totalDuration) {
      const segmentElapsed = elapsedTime - segment1Time - segment2Time;
      const segmentProgress = (segmentElapsed / segment3Time) * 50;
      currentProgress = 50 + segmentProgress;
    }

    currentProgress = Math.min(currentProgress, 100);
    yield put(updateVideoTimerProgress(Math.round(currentProgress)));

    if (currentProgress >= 100) {
      yield put(completeVideoTimer());
      break;
    }
  }
}

// Polling is no longer needed - Firestore listener in component handles real-time updates
// pollMusicStatusWorker removed - component listens to chatHistory changes directly

// Funkcja parsowania dla ogłoszeń
const parseAdvertisementSuggestions = (text) => {
  const lines = text.split("\n").filter((line) => line.trim());
  const suggestions = [];
  let currentSuggestion = null;
  for (const line of lines) {
    const numberedMatch = line.match(/^(\d+\.\s+.*?)(?:\s{2,}|\.\s+|$)(.*)/);
    if (numberedMatch) {
      const title = numberedMatch[1].trim();
      const description = numberedMatch[2].trim();
      currentSuggestion = { title, description };
      suggestions.push(currentSuggestion);
      continue;
    }
    if (currentSuggestion) {
      currentSuggestion.description += (currentSuggestion.description ? " " : "") + line.trim();
    }
  }
  return suggestions.map((suggestion) => ({
    title: suggestion.title,
    description: suggestion.description.trim() || "",
  }));
};

// Funkcja parsowania tytułów
const parseArticleTitles = (text) => {
  const lines = text.split("\n").filter((line) => line.trim());
  const titles = [];
  for (const line of lines) {
    const numberedMatch = line.match(/^(\d+\.\s+)(.+)/);
    if (numberedMatch) {
      const title = numberedMatch[2].trim();
      titles.push({ title, description: "" });
    }
  }
  return titles;
};

// Nowa funkcja parsowania dla advanced bota
const parseAdvancedSuggestions = (text, contentType) => {
  if (contentType === 'hashtags') {
    return [{
      title: '',
      description: typeof text === 'string' ? text.trim() : String(text).trim(),
    }];
  }

  const lines = text.split("\n").filter((line) => line.trim());
  const suggestions = [];
  let currentSuggestion = null;
  for (const line of lines) {
    // Dla contentType bez tytułów (post, script, tips, comment)
    if (['post', 'script', 'tips', 'comment'].includes(contentType)) {
      // Sprawdzanie linii numerowanych (np. "1. Post o..." lub "1. Odpowiedź: ...")
      const numberedMatch = line.match(/^(\d+\.\s+.*)/);
      if (numberedMatch) {
        const description = numberedMatch[1].trim(); // "1. Post o..."
        currentSuggestion = { title: "", description };
        suggestions.push(currentSuggestion);
        continue;
      }
    } else {
      // Dla contentType z tytułami (title, hashtags) - stara logika
      const numberedMatch = line.match(/^(\d+\.\s+.*?)(?:\s{2,}|\.\s+|$)(.*)/);
      if (numberedMatch) {
        const title = numberedMatch[1].trim();
        const description = numberedMatch[2].trim();
        currentSuggestion = { title, description };
        suggestions.push(currentSuggestion);
        continue;
      }
      const boldMatch = line.match(/^\*\*(.+?)\*\*(?:\s{2,}|\.\s+|$)(.*)/);
      if (boldMatch) {
        const title = boldMatch[1].trim();
        const description = boldMatch[2].trim();
        currentSuggestion = { title, description };
        suggestions.push(currentSuggestion);
        continue;
      }
    }

    // Jeśli linia nie jest tytułem, dodaj do opisu bieżącej sugestii
    if (currentSuggestion) {
      currentSuggestion.description += (currentSuggestion.description ? " " : "") + line.trim();
    }
  }
  return suggestions.map((suggestion) => ({
    title: suggestion.title,
    description: suggestion.description.trim() || "",
  }));
};

// Stara funkcja parsowania dla innych botów
const parseSuggestions = (text) => {
  const lines = text.split("\n").filter((line) => line.trim());
  const suggestions = [];
  let currentSuggestion = null;
  for (const line of lines) {
    // Sprawdzanie tytułów numerowanych (np. "1. Tytuł Opis" lub "1. Tytuł")
    const numberedMatch = line.match(/^(\d+\.\s+.*?)(?:\s{2,}|\.\s+|$)(.*)/);
    if (numberedMatch) {
      const title = numberedMatch[1].trim(); // "1. Tytuł"
      const description = numberedMatch[2].trim(); // "Opis" lub pusty string
      currentSuggestion = { title, description };
      suggestions.push(currentSuggestion);
      continue;
    }

    // Sprawdzanie tytułów pogrubionych (np. "**Tytuł** Opis" lub "**Tytuł**")
    const boldMatch = line.match(/^\*\*(.+?)\*\*(?:\s{2,}|\.\s+|$)(.*)/);
    if (boldMatch) {
      const title = boldMatch[1].trim(); // "Tytuł"
      const description = boldMatch[2].trim(); // "Opis" lub pusty string
      currentSuggestion = { title, description };
      suggestions.push(currentSuggestion);
      continue;
    }

    // Jeśli linia nie jest tytułem, dodaj do opisu bieżącej sugestii
    if (currentSuggestion) {
      currentSuggestion.description += (currentSuggestion.description ? " " : "") + line.trim();
    }
  }

  // Przycinanie opisów i usuwanie nadmiarowych spacji
  return suggestions.map((suggestion) => ({
    title: suggestion.title,
    description: suggestion.description.trim() || "",
  }));
};

const parseSearchSuggestions = (text) => {
  if (typeof text !== "string" || text.trim() === "") {
    return [];
  }
  const suggestions = [];
  const regex =
    /\*\*Tytuł:\*\*\s*(.*?)\s*\*\*Opis:\*\*\s*(.*?)\s*\*\*Link:\*\*\s*\(?\[.*?\]\((https?:\/\/[^)]+)\)\)?/sg;

  let match;
  while ((match = regex.exec(text)) !== null) {
    suggestions.push({
      title: match[1].trim(),
      description: match[2].trim(),
      link: match[3].trim(),
    });
  }

  return suggestions;
};

const parseDietSuggestions = (text) => {
  if (typeof text !== "string") {
    return [];
  }
  const suggestions = [];
  const lines = text.split("\n");
  lines.forEach((line) => {
    if (line.match(/^\d+\.\s*Tytuł:/)) {
      const titleMatch = line.match(/Tytuł:\s*(.*?)Opis:/);
      const descriptionMatch = line.match(/Opis:\s*(.*)/);
      if (titleMatch && descriptionMatch) {
        suggestions.push({
          title: titleMatch[1].trim(),
          description: descriptionMatch[1].trim(),
        });
      }
    }
  });
  return suggestions;
};

export function* dataSaga() {
  yield takeLatest(fetchData.type, fetchDataWorker);
  yield takeLatest("FETCH_VIDEO_SUGGESTIONS", fetchSuggestionsWorker);
  yield takeLatest("FETCH_FACEBOOK_SUGGESTIONS", fetchSuggestionsWorker);
  yield takeLatest("FETCH_SEARCH_SUGGESTIONS", fetchSuggestionsWorker);
  yield takeLatest("FETCH_ADVERTISEMENT_SUGGESTIONS", fetchAdvertisementSuggestionsWorker);
  yield takeLatest("FETCH_DIET_SUGGESTIONS", fetchDietSuggestionsWorker);
  yield takeLatest("FETCH_ADVANCED_SUGGESTIONS", fetchAdvancedSuggestionsWorker);
  yield takeLatest("FETCH_COMMENT_RESPONSE", fetchCommentResponseWorker);
  yield takeLatest(fetchSuggestionDetails.type, fetchSuggestionDetailsWorker);
  yield takeLatest("FETCH_IMAGE", fetchImageWorker);
  yield takeLatest("FETCH_LEGAL_ADVICE", fetchLegalAdviceWorker);
  yield takeLatest("GENERATE_LEGAL_DOCUMENT", generateLegalDocumentWorker);
  yield takeLatest(saveChatHistory.type, saveChatHistoryWorker);
  yield takeLatest("FETCH_CHAT_HISTORY", fetchChatHistoryWorker);
  yield takeLatest("FETCH_LAST_DIET_PLAN", fetchLastDietPlanWorker);
  yield throttle(1100, "CHANGE_THEME", changeThemeAfterDelayWorker);
  yield takeEvery("TIME_UPDATE", setTimeOfDayWorker);
  yield fork(watchAuthStateChanges);
  yield takeLatest(fetchRestrictedData.type, fetchRestrictedDataWorker);
  yield takeLatest("FETCH_ARTICLE_TITLES", fetchArticleTitlesWorker);
  // Music generation now handled by component + Firestore listener (like VideoCreator)
  // yield takeLatest("FETCH_MUSIC", fetchMusicWorker);
  yield takeLatest(fetchActiveSubscription.type, fetchActiveSubscriptionWorker);
  yield takeLatest(fetchUserData.type, fetchUserDataWorker);
  yield takeLatest("videoGenerationCompleted", videoGenerationCompletedWorker);
  // Timer wideo – uruchamiany akcją z UI, bez logiki API
  yield takeLatest(startVideoProgressTimer.type, videoProgressTimerWorker);
  // Timer muzyczny – uruchamiany akcją z UI, bez logiki API
  yield takeLatest(startMusicProgressTimer.type, musicProgressTimerWorker);
}